<template>
  <div class="flex justify-start rounded-xl">
    <a :href="url" target="_blank">
      <div class="flex h-20 w-28">
        <img :src="icon" alt="icon" class="object-contain">
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'QuickAccessLinksComponent',
  props: {
    url: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
  },
};
</script>
